import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { Button } from "reactstrap";
import videoItemList from "./catalog_list";
import { Col, Row } from 'reactstrap';
import $ from 'jquery';
class Catalog extends PureComponent {
  static propTypes = {
    items: PropTypes.object
  };

  componentDidMount() {
    $("body").on("contextmenu", "img", function(e) {
      return false;
    });
  }

  componentWillUnmount() {
    $(document).unbind("contextmenu")
  }

  render() {
    const currentVideoID = (videoItemList['currentMonthsVideo'][0].id).toString()
    return (
      <div className="catalog-items__wrap">
        <div className="video-items">
          <div style={{ width: "100%"}}>
            <div style={{ margin: "15px 70px 0" }}>
                <Row>
                    <Col id="test1" lg={2} md={4} sm={2}>
                      <section style={{
                        float: "left",  
                        margin: "0 auto"
                      }}>
                        {/* <Button
                          className={"typeform-share button btn btn-outline-danger"}
                          outline={this.props.active !== "hipaa" || this.props.active !== "security"}
                          color="primary"
                          style={{
                            textAlign: "center",
                            width: "100%",
                            margin: "0 auto",
                            animation: "shadow-pulse 5.5s 5",
                            WebkitFontSmoothing: 'antialiased,-moz-osx-font-smoothing:grayscale'
                          }}
                          onClick={() => {
                            this.props.history.push(`/app/training/security/${currentVideoID}`);
                          }}
                        >
                          {" "}
                          This Month's Video{" "}
                        </Button> */}
                      </section>
                    </Col>
                    <Col id="test2" lg={8} md={8}  sm={8}>
                      <section style={{ textAlign: "center" }}>
                      {/* {this.props.active === 'security' ?
                      <div>
                        <Button
                        className={"typeform-share button btn btn-outline-danger"}
                        outline={this.props.active !== "hipaa" || this.props.active !== "security"}
                        color="primary"
                        style={{
                          textAlign: "center",
                          width: "inherit",
                          animation: "shadow-pulse 5.5s 5",
                          WebkitFontSmoothing: 'antialiased,-moz-osx-font-smoothing:grayscale'
                        }}
                        onClick={() => {
                          this.props.history.push(`/app/training/security/${currentVideoID}`);
                        }}
                      >
                        {" "}
                        This Month's Video{" "}
                      </Button>

                      <Button
                      //className={"typeform-share button btn btn-outline-danger"}
                      outline={this.props.active !== "hipaa"}
                      color="primary"
                      style={{
                        textAlign: "center",
                        width: "inherit",
                      }}
                      onClick={() => {
                        this.props.history.push("/app/training/securityawareness");
                      }}
                    >
                      {" "}
                      Take The Quiz{" "}
                    </Button> 
                    </div>
                      : this.props.active === 'hipaa' ?
                      <Button
                      outline={this.props.active === "hipaa"}
                        color="primary"
                        style={{
                          textAlign: "center",
                          width: "inherit",  
                        }}
                        onClick={() => {
                          this.props.history.push("/app/training/hipaaawarenessquiz");
                        }}
                      >
                        {" "}
                        Take The Quiz{" "}
                      </Button>
                      :
                      <Button
                      outline={this.props.active === "pci"}
                        color="primary"
                        style={{
                          textAlign: "center",
                          width: "inherit",  
                        }}
                        onClick={() => {
                          this.props.history.push("/app/training/pciawarenessquiz");
                        }}
                      >
                        {" "}
                        Take The Quiz{" "}
                      </Button>
                    } */}
                      

                        {/* <Button
                          outline={this.props.active !== "security"}
                          color="primary"
                          style={{ width: "inherit" }}
                          onClick={() => {
                            this.props.history.push("/app/training/security");
                          }}
                        >
                          {" "}
                          Security Awareness{" "}
                        </Button> */}

                                           
                        {/* <Button
                          outline={this.props.active !== "hipaa"}
                          color="primary"
                          style={{ width: "inherit" }}
                          onClick={() => {
                            this.props.history.push("/app/training/hipaa");
                          }}
                        >
                          {" "}
                          HIPAA{" "}
                        </Button> */}

                      </section>
                    </Col>
                    {/* <Col lg={4} md={2} sm={2} id="test3">
                    </Col> */}
                </Row>
            </div>
          </div>

          {/* {this.props.active === "hipaa" ? (
            <React.Fragment>
              {this.props.items[this.props.active].map(item => (
                <div className="video-item" key={item.id}>
                  <Link
                    className="catalog-item__link"
                    to={`/app/training/${this.props.active}/${item.id}`}
                  >
                    <div className="video-wrapper">
                      <div id="tour-training-items" className="catalog-item__img-wrap">
                        <img
                          id="video-item__img"
                          className="video-item__img"
                          src={item.thumbnail}
                          alt="video-item-img"
                        />
                      </div>
                      <h5 className="video-item__title">{item.title}</h5>
                    </div>
                  </Link>
                </div>
              ))
              } */}
              {/* <div style={{ marginLeft: "43%", textAlign: "center" }}>
                <Button
                  className={"typeform-share button btn btn-outline-danger"}
                  outline={this.props.active !== "hipaaawarenessquiz"}
                  color="primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    animation: "shadow-pulse 1.5s 5",
                    WebkitFontSmoothing: 'antialiased,-moz-osx-font-smoothing:grayscale'
                  }}
                  onClick={() => {
                    this.props.history.push("/app/training/hipaaawarenessquiz");
                  }}
                >
                  {" "}
                  Take HIPAA Quiz{" "}
                </Button>
              </div> */}
            {/* </React.Fragment>
          ) :
            ( */}
              <React.Fragment>
                {this.props.items[this.props.active].map(item => (
                  <div className="video-item" key={item.id}>
                    <Link
                      className="catalog-item__link"
                      to={`/app/training/${this.props.active}/${item.id}`}
                    >
                      <div className="video-wrapper">
                        <div className="catalog-item__img-wrap">
                          <img
                            className="video-item__img"
                            src={item.thumbnail}
                            alt="video-item-img"
                            style={{
                              pointerEvents: "none"
                            }}
                          />
                        </div>
                        <h5 className="video-item__title">{item.title}</h5>
                      </div>
                    </Link>
                  </div>

                ))
                }
              </React.Fragment>
            {/* )} */}
        </div>
      </div>
    );
  }
}

export default withRouter(Catalog);



// WEBPACK FOOTER //
// ./src/components/tour/training/components/ProductItems.js